module.exports = __webpack_public_path__ + "static/media/93inovasi2.1d085965.png";